import DropdownMenubar from "../Components/Menubar/DropdownMenubar";
import { BiSolidEdit } from "react-icons/bi";
import { MdDelete } from "react-icons/md";

const DD = (MenuItems) => {
  return (
    <div className="p-3">
      <DropdownMenubar
        menuItem={[
          {
            label: "Action",
            items: MenuItems,
          },
        ]}
      />
    </div>
  );
};

const getVendorInfo = (row, handleCellClick) => {
  return DD([
    {
      label: "UPDATE",
      icon: <BiSolidEdit style={{ color: " rgb(15 61 100)" }} />,
      command: () => {
        handleCellClick(row, true);
      },
    },
    {
      label: "DELETE",
      icon: <MdDelete style={{ color: " rgb(15 61 100)" }} />,
      command: () => {
        handleCellClick(row, false);
      },
    },
  ]);
};
export const columns = [
  // {
  //   field: "order_id",
  //   header: "#",
  //   accessor: (row, handleCellClick,) => (
  //     <>
  //       <div onClick={() => handleCellClick(row, "order_id")} className="">
  //         <p>{}</p>
  //       </div>
  //     </>
  //   ),
  // },
  {
    field: "vehicalType",
    header: "Vehical Type",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "vehicalType")} className="">
          <p>{row?.vehicalType}</p>
        </div>
      </>
    ),
  },
  {
    field: "vehicalSubType",
    header: "Sub Vehicle type",
    accessor: (row, handleCellClick) => (
      <>
        <div
          onClick={() => handleCellClick(row, "vehicalSubType")}
          className=""
        >
          <p>{row?.vehicalSubType}</p>
        </div>
      </>
    ),
  },

  {
    field: "action",
    header: "Action",
    // accessor: (row, handleCellClick) => (
    //   <>
    //     <div onClick={() => handleCellClick(row, "action")} className="">
    //       <BsThreeDotsVertical />
    //     </div>
    //   </>
    // ),
    accessor: (row, handleCellClick) => getVendorInfo(row, handleCellClick),
  },
];

export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};

export const filters = [
  {
    filterType: "Delivery Type",
    inputName: "vehicalType",
    options: [
      {
        name: "Two-Wheeler",
        code: "Two-Wheeler",
      },
      {
        name: "Four-Wheeler",
        code: "Four-Wheeler",
      },
      {
        name: "Commercial",
        code: "commercial",
      },
    ],
  },
];

export const canlenderFilter = {
  filterType: "Order Date",
  inputName: "order_date",
  maxDate: new Date(),
};
